module.exports = __webpack_public_path__ + "static/media/log-icon.65cc7a94.svg";